import { createFileRoute } from "@tanstack/react-router";
import { getProductSales, listProductOptions } from "api-client";
import { z } from "zod";

import { PRODUCT_PAYMENTS_PAGE_SIZE } from "src/helpers/productPaymentsPageQuery";
import { getProductSalesMonth } from "src/helpers/productSalesMonth";
import { loaderHandler } from "src/lib/loaderHandler";
import { CoachProductsSalesPage } from "src/pages/CoachProductsSalesPage";

const routeSearchSchema = z.object({
  date: z.string().optional(),
  products: z.array(z.string()).optional(),
  q: z.string().optional(),
  p: z.number().optional(),
  ps: z.number().optional(),
});

export const Route = createFileRoute("/_auth/_coach/products/_tabs/sales")({
  component: CoachProductsSalesPage,
  validateSearch: routeSearchSchema,
  ssr: true,
  shouldReload: false,
  loaderDeps: ({ search }) => {
    return search;
  },
  async loader({ deps }) {
    return await loaderHandler(async () => {
      const [sales, products] = await Promise.all([
        getProductSales({
          query: {
            month: getProductSalesMonth(deps.date),
            productIds: deps.products,
            q: deps.q,
            pageIndex: deps.p ?? 0,
            pageSize: deps.ps ?? PRODUCT_PAYMENTS_PAGE_SIZE,
          },
        }).then((res) => {
          return res.data.data;
        }),
        listProductOptions().then((res) => {
          return res.data.data;
        }),
      ]);

      return { data: { sales, products } };
    });
  },
});
